import { Component, effect, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import QRCode from 'qrcode';

@Component({
  selector: 'shared-qrcode',
  imports: [],
  template: '',
  host: {
    '[innerHTML]': 'sanitizedSvg()'
  },
  styleUrl: './qrcode.scss',
})
export class Qrcode {

  value = input.required<string>();
  sanitizedSvg = signal<SafeHtml>('');
  private sanitizer = inject(DomSanitizer);

  constructor() {
    effect(async () => {
      if (!this.value()) {
        this.sanitizedSvg.set('');
        return;
      }
      const image = await QRCode.toString(this.value(), {
        type: 'svg',
        errorCorrectionLevel: 'M',
        width: 128,
        margin: 1,
      });
      this.sanitizedSvg.set(this.sanitizer.bypassSecurityTrustHtml(image));
    });
  }
}
